export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/life-services-image2-ae9633af7f7a5a6cdbd185053e08c2ee.png";